import { useLocation } from "react-router-dom";
import T from "../translations/Translations";

import "./LoadingSvg3.scss";

const LoadingSvg3 = () => {
    const location = useLocation();
    return (
        <div className="loading-overlay-3 loading-center-3">
            <div className="svg-background-3">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
            </div>
            {!location.pathname.includes("open-enrollment") && (
                <div className="loading-text-3">{T({ key: "Global_Loading" })}</div>
            )}
        </div>
    );
};

export default LoadingSvg3;
